import gql from 'graphql-tag'

const getAllShortUrlQueries = gql`
  query GetAllShortUrls($page: Int, $size: Int) {
    allShortUrls(page: $page, size: $size) {
      hits {
        id
        sourceUrl
        targetUrl
      }
      totalHits
      page
      size
      totalPages
    }
  }
`

export default getAllShortUrlQueries
